import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	title: {
		id: 'browser-storage-controls.consent-banner-modal.title',
		defaultMessage: 'Cookie preferences',
		description: 'Cookie preferences modal dialog title.',
	},
	description: {
		id: 'browser-storage-controls.consent-banner-modal.description',
		defaultMessage:
			"We respect your right to privacy, so you can select which cookies you allow. However, <bold>strictly necessary</bold> cookies are always allowed as they're essential for our products to function. They don't store any personally identifiable information or track your browsing habits. {link}",
		description: 'Cookie preferences modal dialog description.',
	},
	confirmBtn: {
		id: 'browser-storage-controls.consent-banner-modal.confirm.button',
		defaultMessage: 'Confirm',
		description: 'Cookie preferences modal dialog confirm button.',
	},
	cancelBtn: {
		id: 'browser-storage-controls.consent-banner-modal.cancel.button',
		defaultMessage: 'Cancel',
		description: 'Cookie preferences modal dialog cancel button.',
	},
	trackingLink: {
		id: 'browser-storage-controls.consent-banner-modal.tracking.link',
		defaultMessage: 'Atlassian cookies and Tracking notice',
		description: 'Cookie preferences modal link to tracking notice page.',
	},
	performanceOption: {
		id: 'browser-storage-controls.consent-banner-modal.performance.option',
		defaultMessage: 'Allow performance cookies',
		description: 'Cookie preferences modal performance option.',
	},
	performanceOptionDescription: {
		id: 'browser-storage-controls.consent-banner-modal.performance.description',
		defaultMessage:
			"These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our product. All the information these cookies collect is aggregated and therefore anonymous. If you don't allow these cookies, we won't know when you've visited our product and won't be able to monitor its performance.",
		description: 'Cookie preferences modal performance option description.',
	},
	functionalOption: {
		id: 'browser-storage-controls.consent-banner-modal.functional.option',
		defaultMessage: 'Allow functional cookies',
		description: 'Cookie preferences modal functional option.',
	},
	functionalOptionDescription: {
		id: 'browser-storage-controls.consent-banner-modal.functional.description',
		defaultMessage:
			"These cookies enable our product to provide enhanced functionality and personalization. They may be set by us or by third party providers whose services we've added to our pages. If you don't allow these cookies, some or all of these services may not function properly.",
		description: 'Cookie preferences modal functional option description.',
	},
	marketingOption: {
		id: 'browser-storage-controls.consent-banner-modal.targeting.option',
		defaultMessage: 'Allow targeting cookies',
		description: 'Cookie preferences modal targeting option.',
	},
	marketingOptionDescription: {
		id: 'browser-storage-controls.consent-banner-modal.targeting.description',
		defaultMessage:
			"These cookies may be set through our product by our partners. They don't store directly personal information, but are based on identifying your unique browser and internet device. If you don't allow these cookies, you'll experience less targeted advertising.",
		description: 'Cookie preferences modal targeting option description.',
	},
	// New messages
	summaryDescription: {
		id: 'browser-storage-controls.consent-banner-modal.summary.description.082624',
		defaultMessage: 'Because we value your privacy, you can select which cookies you allow. {link}',
		description: 'Cookie preferences modal dialog summary description.',
	},
	strictDescription: {
		id: 'browser-storage-controls.consent-banner-modal.strict.description.082624',
		defaultMessage:
			"Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
		description: 'Cookie preferences modal strict description.',
	},
	trackingLinkTemp: {
		id: 'browser-storage-controls.consent-banner-modal.tracking.link.082624',
		defaultMessage: 'Review our cookies and tracking notice',
		description: 'Cookie preferences modal link to tracking notice page.',
	},
	functionalOptionTemp: {
		id: 'browser-storage-controls.consent-banner-modal.functional.option.082624',
		defaultMessage: 'Allow functional cookies',
		description: 'Cookie preferences modal functional option.',
	},
	functionalOptionDescriptionTemp: {
		id: 'browser-storage-controls.consent-banner-modal.functional.description.082624',
		defaultMessage: 'Provides enhanced functionality and personalization.',
		description: 'Cookie preferences modal functional option description.',
	},
	analyticalOptionTemp: {
		id: 'browser-storage-controls.consent-banner-modal.analytical.option.082624',
		defaultMessage: 'Allow analytical cookies',
		description: 'Cookie preferences modal analytical option.',
	},
	analyticalOptionDescriptionTemp: {
		id: 'browser-storage-controls.consent-banner-modal.analytical.description.082624',
		defaultMessage: 'Measures usage to improve product performance',
		description: 'Cookie preferences modal analytical option description.',
	},
	marketingOptionTemp: {
		id: 'browser-storage-controls.consent-banner-modal.marketing.option.082624',
		defaultMessage: 'Allow marketing cookies',
		description: 'Cookie preferences modal marketing option.',
	},
	marketingOptionDescriptionTemp: {
		id: 'browser-storage-controls.consent-banner-modal.marketing.description.082624',
		defaultMessage: 'Used for targeted advertising.',
		description: 'Cookie preferences modal marketing option description.',
	},
});
